import { excludeFrom } from "@mcwd/typescript-type-guards";
export const FormInputTagName = ["input", "select", "textarea"] as const;
export type FormInputTagName = (typeof FormInputTagName)[number];

export const HTMLInputElementTypeAttributeValue = [
  "checkbox",
  "color",
  "date",
  "datetime-local",
  "email",
  "file",
  "hidden",
  "month",
  "number",
  "password",
  "radio",
  "range",
  "search",
  "submit",
  "tel",
  "text",
  "time",
  "url",
  "week",
] as const;

export type HTMLInputElementTypeAttributeValue = (typeof HTMLInputElementTypeAttributeValue)[number];


export const HtmlInputTypeName = [
  ...excludeFrom(FormInputTagName, "input"),
  ...HTMLInputElementTypeAttributeValue
] as const;

export type HtmlInputTypeName = typeof HtmlInputTypeName[ number ];

export type HtmlInputTypeNameToHTMLElement<TType extends FormInputTagName | HTMLInputElementTypeAttributeValue> =
  TType extends "select"
    ? HTMLSelectElement
    :
  TType extends "textarea"
    ? HTMLTextAreaElement
    :
  TType extends HTMLInputElementTypeAttributeValue | "input"
    ? HTMLInputElement
    : never;